/**
 * Detect if the app is running as an installed PWA (standalone), not a browser tab.
 */
export function isPwa() {
  if (typeof window === "undefined") return false;

  const standaloneMedia = window.matchMedia?.("(display-mode: standalone)")?.matches;
  const fullscreenMedia = window.matchMedia?.("(display-mode: fullscreen)")?.matches;
  const minimalUiMedia = window.matchMedia?.("(display-mode: minimal-ui)")?.matches;
  const iosStandalone = window.navigator.standalone === true;

  return Boolean(standaloneMedia || fullscreenMedia || minimalUiMedia || iosStandalone);
}

export default isPwa;
